import {FAILURE, PENDING, SUCCESS} from '../../constants'

const ACTION = 'GET_ITEM_HISTORY'

export const GIH_FAILURE = `${ACTION}_${FAILURE}`
export const GIH_PENDING = `${ACTION}_${PENDING}`
export const GIH_SUCCESS = `${ACTION}_${SUCCESS}`
